import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCustomerDialogContentComponent } from './create-customer-dialog-content/create-customer-dialog-content.component';
import { RegisterUserComponent } from '../../authentication/register-user/register-user.component';


@Component({
  selector: 'app-create-customer-dialog',
  template: ''
})
export class CreateCustomerDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(RegisterUserComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    dialogRef.componentInstance.isOperatorView = true;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
